<div class="app-layout-no-sidenav">
  <ftr-header-logged-out />
  <div class="app-layout-no-sidenav__content-wrapper">
    <main
      id="main-content"
      [ngClass]="[
        appContentWindowSelector,
        !routeData()?.whiteBackground ? appContentWindowSelectorGreyBackground : '',
      ]"
      cdkScrollable
    >
      <ng-content />
    </main>
  </div>
  <ftr-footer-logged-out />
</div>
